<template>
	<!--
		Painel principal dos "grandes números" do dashboard.

		Esse componente exibe os indicadores principais de sinistro:
		- Taxa Mensal de Sinistro
		- Taxa Anual de Sinistro

		A divisão de vidas por empresa agora será exibida em outro componente,
		através de tabela e gráfico de colunas.
	-->
	<div class="dashboard__panel columns is-multiline big-numbers">
		<!-- Título do bloco -->
		<h3 class="title">Como estão os números?</h3>

		<!--
			Primeiro card:
			Taxa Mensal de Sinistro.

			O valor vem do backend dentro de:
			indicators.monthly_rate
		-->
		<div class="column is-12-mobile is-half-desktop numbers bordered">
			<h5 class="has-text-danger">
				{{ formatPercent(indicators.monthly_rate) }}
			</h5>

			<p>
				Taxa Mensal <br>
				de Sinistro
			</p>
		</div>

		<!--
			Segundo card:
			Taxa Anual de Sinistro.

			O valor vem do backend dentro de:
			indicators.annual_rate
		-->
		<div class="column is-12-mobile is-half-desktop numbers">
			<h5 class="has-text-warning">
				{{ formatPercent(indicators.annual_rate) }}
			</h5>

			<p>
				Taxa Anual <br>
				de Sinistro
			</p>
		</div>
	</div>
</template>

<script>
/*
 * Import original que já existia no projeto.
 *
 * Mantido para preservar o comportamento atual do componente
 * e evitar remover alguma dependência global usada pelo projeto.
 */
import '@/mixins/date'

export default {
	/*
	 * Nome do componente.
	 */
	name: 'BigNumbers',

	/*
	 * Props recebidas do Dashboard.vue.
	 *
	 * O Dashboard.vue envia o objeto indicators para este componente:
	 *
	 * <BigNumbers :indicators="indicators" />
	 */
	props: {
		/*
		 * indicators é o objeto de indicadores retornado pelo backend.
		 *
		 * Estrutura esperada:
		 * {
		 *   monthly_rate: 0,
		 *   annual_rate: 0
		 * }
		 */
		indicators: {
			type: Object,
			required: false,

			/*
			 * Valor padrão usado enquanto a API ainda está carregando
			 * ou caso indicators venha vazio.
			 */
			default: () => ({
				monthly_rate: 0,
				annual_rate: 0
			})
		}
	},

	methods: {
		/*
		 * Formata valores percentuais no padrão brasileiro.
		 *
		 * Exemplos:
		 * 0      => "0,0%"
		 * 0.02   => "0,02%"
		 * 1.5    => "1,5%"
		 * 12.34  => "12,34%"
		 */
		formatPercent(value) {
			const number = Number(value || 0)

			return `${number.toLocaleString('pt-BR', {
				minimumFractionDigits: 1,
				maximumFractionDigits: 2
			})}%`
		}
	}
}
</script>